module.exports = (__webpack_require__(0))(206);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/PluginConfigBreadcrumbWidget.js from dll-reference girder_plugin_large_image
// module id = 36
// module chunks = 0